import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "rgb(61,162,131)",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgb(61,162,131)",
    maxWidth: "fit-content"
  },
}));
